<template>
  <div></div>
</template>

<script>
export default {
  name: "Recover",
};
</script>

<style lang="scss" scoped>
</style>